<script lang="ts">
  interface Props {
    title: string
    value: number
    polarity: string
    classes: string
    isLoading: boolean
  }

  let {
    title = 'Previous',
    value = 0,
    polarity = 'positive',
    classes = '',
    isLoading = false,
  }:Props = $props();

  let displayValue = $derived(value.toFixed(1));
  let valLength = $derived(displayValue.toString().length);
</script>

{#if value >= 0}
<div class="{classes} mini-percentage icon-{polarity} value-length-{valLength}" aria-live="polite" aria-busy="{ isLoading }">
  <p class="mini-percentage--title">{title}</p>
  <div class="row-wrap">
    <div class="text-wrap"><p class="mini-percentage--value">{displayValue}%</p></div>
    <div class="img-wrap">
      {#if polarity === 'zero'}
      <div class="mini-percentage--empty"></div>
      {:else if polarity === 'positive'}
      <svg role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 57 56">
          <defs>
            <style>
              .cls-3{fill:#09ac00;}
            </style>
          </defs>
          <g class="cls-1">
            <g data-name="Layer 2">
              <g data-name="Layer 1">
                <g>
                  <g data-name="Hero Content Gray Txt">
                    <g>
                      <path class="cls-3" d="M9.87,47.07a5.44,5.44,0,0,0,3.43-1.22l13-10.63L39.5,46a5.43,5.43,0,1,0,6.86-8.42L29.77,24a5.44,5.44,0,0,0-6.87,0L6.44,37.42a5.44,5.44,0,0,0,3.43,9.65Z"/>
                      <path class="cls-3" d="M9.87,28.88a5.44,5.44,0,0,0,3.43-1.22L26.34,17,39.5,27.76a5.43,5.43,0,1,0,6.86-8.42L29.77,5.82a5.44,5.44,0,0,0-6.87,0L6.44,19.23a5.44,5.44,0,0,0,3.43,9.65Z"/>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      {:else}
        <svg role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 56 56" style="transform:rotate(180deg)">
          <defs>
            <style>.cls-3{fill:#df0122;}</style>
          </defs>
          <g class="cls-1">
            <g data-name="Layer 2">
              <g data-name="Layer 1">
                <g>
                  <g data-name="Hero Content Gray Txt">
                    <g>
                      <g class="Fail">
                        <path class="cls-3" d="M9.87,47.07a5.44,5.44,0,0,0,3.43-1.22l13-10.63L39.5,46a5.43,5.43,0,1,0,6.86-8.42L29.77,24a5.44,5.44,0,0,0-6.87,0L6.44,37.42a5.44,5.44,0,0,0,3.43,9.65Z" />
                        <path class="cls-3" d="M9.87,28.88a5.44,5.44,0,0,0,3.43-1.22L26.34,17,39.5,27.76a5.43,5.43,0,1,0,6.86-8.42L29.77,5.82a5.44,5.44,0,0,0-6.87,0L6.44,19.23a5.44,5.44,0,0,0,3.43,9.65Z" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      {/if}
    </div>
  </div>
</div>
{/if}

<style type="text/scss">
  .mini-percentage {
    max-width: 190px;
    margin: 0 auto;
  }

  .mini-percentage.icon-left .row-wrap {
    flex-direction: row;
  }

  .row-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  p {
    line-height: 1;
    margin: 0;
    padding: 0;
  }

  p.mini-percentage--title {
    text-transform: uppercase;
    font-size: 2.4rem;
    margin: 0;
    padding: 0 6px;
  }

  p.mini-percentage--value {
    font-size: 2.8rem;
  }

  .value-length-3 p.mini-percentage--value {
    font-size: 2.4rem;
  }

  svg {
    width: 100%;
    max-width: 5rem;
  }

  /* svg styles from AI */
  svg .cls-1{
    isolation:isolate;
  }

  /* setting appropriate svg path color */
  .icon-positive svg .cls-3 {
    fill:#09ac00;
  }

  .icon-negative svg .cls-3 {
    fill:#df0122;
  }

  .img-wrap, .text-wrap {
    font-size: 2.8rem;
    padding: 0 0 0 8px;
    font-weight: bold;
  }

  .img-wrap {
    max-width: 80px;
    width: 100%;
  }

  .text-wrap {
    text-align: left;
    flex-grow: 2;
  }

  .value-length-2 .text-wrap {
    align-self: flex-start;
    padding-top: 10px;
  }
  .icon-zero .text-wrap{
    text-align:center!important;
  }
  .icon-zero .img-wrap{
    display:none !important;
  }
</style>  